import React from "react";
import MasterLayout from "../masterLayout/MasterLayout";
import NotifyMeListLayer from "../components/NotifyMeListLayer";

const NotifyMeListPage = () => {
    return (
        <MasterLayout>
            <NotifyMeListLayer />
        </MasterLayout>
    );
};

export default NotifyMeListPage;
